import { useCallback } from 'react';

import { Tooltip, POSITIONS } from '@hivebrite/design-system/Tooltip';

import { useQuillEditorContext } from 'hb-react/shared/components/DesignSystem/QuillEditor/contexts/QuillEditorContext';
import ToolbarItem from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarItem';

const Icon = (props) => (
  <svg {...props} viewBox="0 0 467.765 467.765">
    <path
      fill="currentColor"
      d="M165.462 175.412c-11.968-12.548-19.286-29.342-19.286-47.679 0-38.186 31.077-69.263 69.263-69.263h164.62V0h-164.62C145.006 0 87.706 57.3 87.706 127.733c0 16.809 3.578 32.82 9.566 47.679zM302.303 292.353c11.968 12.548 19.286 29.342 19.286 47.679 0 38.186-31.077 69.263-69.262 69.263H87.706v58.471h164.62c70.433 0 127.733-57.3 127.733-127.733 0-16.809-3.576-32.822-9.564-47.679l-68.192-.001zM58.471 204.647h350.824v58.471H58.471z"
    />
  </svg>
);

const Strikethrough = ({ onItemClick, value, ...otherProps }) => {
  const { quillRef } = useQuillEditorContext();

  const handleToggleValue = useCallback(() => {
    quillRef.current.format('strike', !value, 'user');
    onItemClick();
  }, [value]);

  return (
    <Tooltip
      initialPosition={POSITIONS.BOTTOM}
      childrenElement={__('Crossed out')}
    >
      <ToolbarItem
        onClick={handleToggleValue}
        isActive
        icon={Icon}
        {...otherProps}
      />
    </Tooltip>
  );
};

Strikethrough.getFormat = (format) => format?.strike;

export default Strikethrough;
